import { makeStyles, Theme } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export interface IStylesProps {
  minHeightDialog: number | string;
}

export default makeStyles<Theme, IStylesProps>((theme: Theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      width: 593
    },
    "& .MuiDialog-scrollPaper": {
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        marginLeft: 84
      },
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        marginLeft: 220
      }
    },
    "& .MuiPaper-rounded": {
      borderRadius: 6
    }
  },
  content: {
    height: (props: IStylesProps) => props.minHeightDialog || "auto",
    padding: 0,
    overflowX: "hidden"
  }
}));
